/** Shared helpers for UiIcon ↔ SVG sprite mapping (no Node fs). */

export const SVG_SPRITE_PUBLIC_PATH = '/sprites/ui-icons.svg'

/** `/svg/icons/cancel.svg` → `icon-icons-cancel` */
export function srcToSymbolId (src: string | null | undefined): string | null {
  if (!src || !src.startsWith('/svg/')) {
    return null
  }

  const relativePath = src.slice('/svg/'.length).replace(/\.svg$/i, '')
  if (!relativePath || relativePath.startsWith('logo/')) {
    return null
  }

  return `icon-${relativePath.split('/').join('-')}`
}

export function isInlineIconSrc (src: string | null | undefined): boolean {
  if (!src) {
    return false
  }

  return (
    src.startsWith('/svg/logo/') ||
    src.startsWith('/svg/trustpilot/') ||
    src.startsWith('/svg/payment-methods/') ||
    src.startsWith('/svg/social-buttons/') ||
    src.startsWith('/svg/icons/colored/')
  )
}
